import styled from 'styled-components';

import { Box } from '@/components/Box';

export const SVG = styled(Box).attrs({
  forwardedAs: 'svg',
})<React.SVGProps<SVGSVGElement>>`
  color: ${({ color }) => color || 'currentColor'};
  display: inline-flex;
  min-width: ${(props) => props.width};
  vertical-align: middle;
  /* Fix rendering bugs in Chrome for hdpi */
  shape-rendering: 'inherit';
  transform: 'translate3d(0,0,0)';
`;
